import React, {useState, useEffect} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import SideNavigationComponent from './sideNavigation/index';
import styles from './Layout.module.scss';
import NoInternetConnection from './shared/networkErrorScreen/index';
import {setErrorStateTemplate, setIsUserLoggedIn, setRemoteConfig} from '../redux/actions/uiActions';
import {_apiHeaderConfigs, makeRequest} from './utils/APIsUtils/httpsUtils';
import config from '../config';
import { fetchMarketLanguages, fetchCountries } from '../redux/actions/commonDataActions';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
const Layout = (props) => {
  const {
    children,
    isUserLoggedIn = false,
    setErrorStateTemplate,
    errorTemplateState,
    remoteConfig,
    setRemoteConfig,
  } = props;
  const [isOnline, setOnline] = useState(true);
  const [errorOccured, setErrorOccured] = useState(false);
  const segment = useSelector(state => state.segment || {});
  const { marketLanguages = {}, marketLanguagesLoader } = useSelector(state => state.commonData);
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const redirect = queryParams.get("redirect");
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    setOnline(navigator.onLine);
    setErrorStateTemplate({
      varient: 'networkError',
      status: false,
    });
  }, []);

  useEffect(() => {
    if (marketLanguages?.marketDefaultLocale?.locale || null) {
      localStorage.setItem('locale', marketLanguages?.marketDefaultLocale?.locale || null);
    }
  }, [marketLanguages])

  window.addEventListener('online', () => {
    setOnline(true);
    setErrorStateTemplate({
      status: false,
      variant: 'networkError',
    });
    window.location.reload();
  });
  window.addEventListener('offline', () => {
    setOnline(false);
    setErrorStateTemplate({
      status: true,
      variant: 'networkError',
    });
  });

  useEffect(()=>{
    if(!isAuthenticated){
      dispatch(setIsUserLoggedIn(false));
      localStorage.clear();
    }
  },[isAuthenticated])

  useEffect(() => {
    if(!isUserLoggedIn) return;
    _apiHeaderConfigs().then((data)=> {
      if (data._accessToken && data._idToken) {
        if (config.is_segmented && segment?.isSegmentAssigned) {
          dispatch(fetchMarketLanguages(history, redirect));
        } else {
          dispatch(fetchMarketLanguages(history, redirect));
        }
      }
    })
  }, [isUserLoggedIn, segment?.marketCode])

  // Fetched separately so it also runs when remoteConfig arrives after login; otherwise
  // the countries list in Redux stays empty until a page fetches it on its own.
  useEffect(() => {
    if(!isUserLoggedIn || !remoteConfig?.user_group_country_targeting) return;
    _apiHeaderConfigs().then((data)=> {
      if (data._accessToken && data._idToken) {
        dispatch(fetchCountries());
      }
    })
  }, [isUserLoggedIn, segment?.marketCode, remoteConfig?.user_group_country_targeting])

  useEffect(() => {
    setErrorOccured(errorTemplateState.status);
  }, [errorTemplateState.status]);

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        {isUserLoggedIn && <SideNavigationComponent />}
        {errorOccured ? <NoInternetConnection /> : children}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isUserLoggedIn: state && state.uiState && state.uiState.isUserLoggedIn,
  errorTemplateState: state && state.uiState && state.uiState.errorTemplateState,
  remoteConfig: state && state.uiState && state.uiState.remoteConfig,
});
const mapDispatchToProps = (dispatch) => ({
  setErrorStateTemplate: (options) => dispatch(setErrorStateTemplate(options)),
  setRemoteConfig: (options) => dispatch(setRemoteConfig(options)),
});

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(Layout));
